/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum HostProtocol {
  NFC = 1,
  BLUETOOTH = 2,
  GSM = 4,
  USB_RLINK = 8,
  USB_CMISIS_DAP = 16,
  WIFI = 32,
  BLE = 64,
  UART = 256,
  MQTT = 512,
  WEBSOCKET = 1024,
  SLAVE_SERVER = 2048,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum TargetProtocol {
  SWD = 0,
  S3P = 1,
  JTAG = 2,
  MODBUS = 3,
  DIRECT_IO = 4,
  SERIAL = 6,
  CUSTOM = 7,
  CAN = 8,
  MODBUS_TCP = 9,
  NONE = 255,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum VariableFormat {
  _1_BIT = 0,
  _8_BITS = 1,
  _16_BITS = 2,
  _32_BITS = 3,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum AppPathType {
  PRIMER_CLOUD_WEB_APP_URL = '$1/',
  URL = '$2/',
  ANDROID_APP_ID = '$4/',
  PRIMER_CLOUD_CONFIG_URL = '$5/',
  AAR_2 = '$6/',
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum SpecialFeature {
  SWD_DIRECT_ACCESS = 100,
  SERIAL_ACCESS = 101,
  MODBUS_DIRECT_ACCESS = 102,
  TAPNPASS_CONTROL_ACCESS = 103,
  SP_CODEEXEC_ACCESS = 104,
  MQTT_IDS_ACCESS = 105,
  VARIABLE_CONFIG_ACCESS = 106,
  FILE_SYSTEM_ACCESS = 107,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface TapVersion {
  major?: number;
  minor?: number;
  patch?: number;
}
